/* Search by photo (search page). Camera button in the search field -> take or upload a photo -> MYM AI visual search
 * -> each match is re-checked by the store (/products/<handle>?view=mym-vs renders a card only when the piece is
 * published and has stock above 0). The backend's exact_match is shown as "Exact match" only when that first piece
 * also passes the store check; otherwise the honest "closest pieces" note. No counts are shown; the photo is never stored. */
(function () {
  var box = document.getElementById('MymVsResults');
  var sheet = document.getElementById('MymVsSheet');
  var trigger = document.querySelector('[data-mym-vs-open]');
  if (!box || !sheet || !trigger) return;
  var camera = document.querySelector('[data-mym-vs-camera]');
  var file = document.querySelector('[data-mym-vs-file]');
  var API = box.dataset.api, LOC = box.dataset.locale === 'ar' ? 'ar' : 'en';
  var ROOT = (box.dataset.root || '/').replace(/\/$/, '');
  var MAX_SHOWN = 12, epoch = 0, lastFocus = null;
  var t = function (k) { return box.dataset['t' + k.charAt(0).toUpperCase() + k.slice(1)] || ''; };
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  document.body.appendChild(sheet); // out of the form and any transformed section, so position: fixed covers the screen
  sheet.setAttribute('data-lenis-prevent', '');

  // phones: shorter placeholder, so it never cuts mid-word next to the two icons;
  // desktop (mouse/trackpad): say that a photo can be pasted
  var form = trigger.closest('form');
  var input = form && form.querySelector('input[type="search"]');
  if (input && trigger.dataset.placeholderShort) {
    var full = !coarse && trigger.dataset.placeholderPaste || input.placeholder, mq = window.matchMedia('(max-width: 749px)');
    var setPh = function () { input.placeholder = mq.matches ? trigger.dataset.placeholderShort : full; };
    setPh(); if (mq.addEventListener) mq.addEventListener('change', setPh); else mq.addListener(setPh);
  }

  // ---------- desktop: paste or drop a photo ----------
  // Cmd/Ctrl+V of a copied image or screenshot anywhere on /search, or drop an image file on the page
  // (the search field shows where). Copied text still pastes as text. The chat window handles its own paste/drop.
  function imageFrom(dt) {
    if (!dt) return null;
    var files = Array.prototype.slice.call(dt.files || []).filter(function (f) { return /^image\//.test(f.type); });
    if (files.length) return files[0];
    var item = Array.prototype.slice.call(dt.items || []).filter(function (i) { return i.kind === 'file' && /^image\//.test(i.type); })[0];
    return item ? item.getAsFile() : null;
  }
  function hasType(dt, type) { return !!dt && Array.prototype.indexOf.call(dt.types || [], type) >= 0; }
  function hasImage(dt) { // while dragging only the file types are known
    return Array.prototype.some.call(dt.items || [], function (i) { return i.kind === 'file' && /^image\//.test(i.type); });
  }
  function inChat(n) { return !!(n && n.closest && n.closest('#mym-ai-root')); }
  if (!coarse && form) {
    document.addEventListener('paste', function (e) {
      if (e.defaultPrevented || inChat(e.target) || hasType(e.clipboardData, 'text/plain')) return; // e.g. cells copied from a spreadsheet
      var f = imageFrom(e.clipboardData);
      if (f) { e.preventDefault(); run(f); }
    });
    var dropOff = null;
    var unmark = function () { clearTimeout(dropOff); form.classList.remove('is-dragover'); };
    document.addEventListener('dragover', function (e) {
      if (!hasType(e.dataTransfer, 'Files') || inChat(e.target)) return;
      e.preventDefault(); // dropping must not open the file in the tab
      if (!hasImage(e.dataTransfer)) { e.dataTransfer.dropEffect = 'none'; return; } // e.g. a PDF: no highlight
      e.dataTransfer.dropEffect = 'copy';
      form.classList.add('is-dragover');
      clearTimeout(dropOff); dropOff = setTimeout(unmark, 160); // dragover repeats while the photo is over the page
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') unmark(); });
    document.addEventListener('dragend', unmark);
    document.addEventListener('drop', function (e) {
      if (!hasType(e.dataTransfer, 'Files') || inChat(e.target)) return;
      e.preventDefault(); unmark();
      var f = imageFrom(e.dataTransfer);
      if (f) run(f);
    });
  }

  // ---------- sheet ----------
  function openSheet() {
    if (!coarse) { file.click(); return; } // desktop: no camera choice, go straight to the file picker
    lastFocus = document.activeElement;
    sheet.hidden = false;
    document.documentElement.classList.add('mym-vs-lock');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); sheet.querySelector('[data-mym-vs-take]').focus(); });
  }
  function closeSheet(restore) {
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('mym-vs-lock');
    setTimeout(function () { sheet.hidden = true; }, 200);
    if (restore !== false && lastFocus) lastFocus.focus();
  }
  trigger.addEventListener('click', openSheet);
  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-mym-vs-close]')) closeSheet();
    else if (e.target.closest('[data-mym-vs-take]')) { closeSheet(false); camera.click(); }
    else if (e.target.closest('[data-mym-vs-upload]')) { closeSheet(false); file.click(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
  [camera, file].forEach(function (inp) {
    inp.addEventListener('change', function () { var f = inp.files && inp.files[0]; inp.value = ''; if (f) run(f); });
  });

  // ---------- photo ----------
  function shrink(f) {
    return new Promise(function (res, rej) {
      if (f.size > 15 * 1024 * 1024) return rej('big');
      if (f.type && !/^image\//.test(f.type)) return rej('type');
      var url = URL.createObjectURL(f), img = new Image();
      img.onload = function () {
        var k = Math.min(1, 800 / Math.max(img.naturalWidth, img.naturalHeight)), c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); URL.revokeObjectURL(url);
        res(c.toDataURL('image/jpeg', 0.85));
      };
      img.onerror = function () { URL.revokeObjectURL(url); rej('type'); };
      img.src = url;
    });
  }

  // ---------- results ----------
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
  function head(photo) {
    box.innerHTML = '';
    var h = el('div', 'mym-vs__head');
    var thumb = el('img', 'mym-vs__thumb'); thumb.src = photo; thumb.alt = t('photo'); thumb.width = 56; thumb.height = 70;
    var txt = el('div', 'mym-vs__head-text');
    var title = el('p', 'eyebrow mym-vs__title', t('head'));
    var status = el('p', 'mym-vs__status');
    txt.appendChild(title); txt.appendChild(status);
    var acts = el('div', 'mym-vs__acts');
    var again = el('button', 'mym-vs__link', t('change')); again.type = 'button'; again.addEventListener('click', openSheet);
    var clear = el('button', 'mym-vs__link', t('clear')); clear.type = 'button';
    clear.addEventListener('click', function () { epoch++; box.hidden = true; box.innerHTML = ''; trigger.focus(); });
    acts.appendChild(again); acts.appendChild(clear);
    h.appendChild(thumb); h.appendChild(txt); h.appendChild(acts);
    box.appendChild(h);
    return { title: title, status: status };
  }
  function skeleton() {
    var ul = el('ul', 'product-grid mym-vs__grid is-loading'); ul.setAttribute('role', 'list'); ul.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 4; i++) {
      var li = el('li'); li.appendChild(el('span', 'mym-vs__ph'));
      li.appendChild(el('span', 'mym-vs__ph-line')); li.appendChild(el('span', 'mym-vs__ph-line mym-vs__ph-line--short'));
      ul.appendChild(li);
    }
    box.appendChild(ul); return ul;
  }
  function card(handle) {
    return fetch(ROOT + '/products/' + encodeURIComponent(handle) + '?view=mym-vs', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { return /data-mym-vs-ok/.test(html) ? html.trim() : ''; })
      .catch(function () { return ''; });
  }
  function isWear(html) { return /data-kind="wear"/.test(html); }
  function fail(ui, grid, code) {
    if (grid) grid.remove();
    ui.status.textContent = t(code === 'big' ? 'big' : code === 'type' ? 'type' : code === 'offline' ? 'offline' : 'error');
    ui.status.classList.add('is-error');
  }

  function run(f) {
    var my = ++epoch;
    shrink(f).then(function (photo) {
      if (my !== epoch) return;
      box.hidden = false;
      var ui = head(photo), grid = skeleton();
      ui.status.textContent = t('loading');
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var slow = setTimeout(function () { if (my === epoch) ui.status.textContent = t('slow'); }, 8000);
      var ctl = 'AbortController' in window ? new AbortController() : null;
      var stop = setTimeout(function () { if (ctl) ctl.abort(); }, 45000);
      fetch(API + '/v1/visual-search', { method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctl && ctl.signal,
        body: JSON.stringify({ image: photo, locale: LOC, limit: 20 }) })
        .then(function (r) { if (r.status === 413) throw 'big'; if (r.status === 422) throw 'type'; if (!r.ok) throw 'error'; return r.json(); })
        .then(function (j) {
          var hs = (j.results || []).map(function (p) { return p.handle; }).filter(Boolean);
          return Promise.all(hs.map(card)).then(function (cards) {
            var exact = j.exact_match === true && !!cards[0];
            // kids' pieces never pad the list (the exact piece itself always stays first);
            // closest pieces: clothing before shoes and accessories
            var rest = cards.filter(function (c, i) { return c && !(exact && i === 0) && !/data-kids/.test(c); });
            if (!exact) rest = rest.filter(isWear).concat(rest.filter(function (c) { return !isWear(c); }));
            return { cards: (exact ? [cards[0]] : []).concat(rest).slice(0, MAX_SHOWN), exact: exact };
          });
        })
        .then(function (res) {
          if (my !== epoch) return;
          clearTimeout(slow); clearTimeout(stop);
          if (!res.cards.length) { grid.remove(); ui.status.textContent = t('none'); return; }
          ui.title.textContent = res.exact ? t('exact') : t('title');
          ui.status.textContent = res.exact ? t('exactNote') : t('low');
          if (res.exact) grid.classList.add('has-exact');
          grid.classList.remove('is-loading'); grid.removeAttribute('aria-hidden');
          grid.innerHTML = res.cards.join('');
          // cards arrive after the page's reveal/shimmer observers ran, so show them here
          grid.querySelectorAll('.reveal').forEach(function (n) { n.classList.add('is-in'); });
          grid.querySelectorAll('.mo-shimmer').forEach(function (m) {
            var img = m.querySelector('img'), done = function () { m.classList.add('is-loaded'); };
            if (!img || img.complete) done(); else { img.addEventListener('load', done); img.addEventListener('error', done); }
          });
        })
        .catch(function (e) {
          clearTimeout(slow); clearTimeout(stop);
          if (my === epoch) fail(ui, grid, navigator.onLine === false ? 'offline' : typeof e === 'string' ? e : 'error');
        });
    }).catch(function (code) {
      if (my !== epoch) return;
      box.hidden = false; var ui = head(''); ui.status.parentNode.parentNode.querySelector('.mym-vs__thumb').remove(); fail(ui, null, code);
    });
  }
})();
